import { render, staticRenderFns } from "./NewTabs.vue?vue&type=template&id=f13c068a&scoped=true&"
import script from "./NewTabs.vue?vue&type=script&lang=js&"
export * from "./NewTabs.vue?vue&type=script&lang=js&"
import style0 from "./NewTabs.vue?vue&type=style&index=0&id=f13c068a&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f13c068a",
  null
  
)

export default component.exports